var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 34,
    viewBox: "0 0 47 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96 29.5725H19.215C21.855 29.5725 23.0625 27.525 23.0625 25.005C23.0625 22.5975 21.855 20.3175 19.215 20.3175H3.96V29.5725ZM3.96 16.83H18.135C20.775 16.83 21.855 14.79 21.855 12.2625C21.855 9.85499 20.775 7.69499 18.135 7.69499L3.96 7.69499V16.83ZM-2.86102e-06 33.06V4.08749L18.135 4.08749C23.1825 4.08749 25.8225 7.81499 25.8225 12.1425C25.8225 14.79 24.9825 16.83 22.8225 18.27C25.4625 19.3575 26.9025 22.4775 26.9025 25.005C26.9025 29.3325 24.2625 33.06 19.215 33.06H-2.86102e-06Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.43 11.9025H40.2375C41.0775 11.9025 41.4375 11.3025 41.4375 10.4625C41.4375 9.735 40.9575 9.015 40.2375 9.015H35.43V11.9025ZM35.43 7.935H39.8775C40.7175 7.935 41.0775 7.215 41.0775 6.495C41.0775 5.775 40.7175 5.0475 39.8775 5.0475H35.43V7.935ZM34.23 12.9825V3.9675L39.8775 3.9675C41.4375 3.9675 42.2775 5.0475 42.2775 6.495C42.2775 7.215 42.0375 7.935 41.3175 8.415C42.1575 8.655 42.6375 9.735 42.6375 10.4625C42.6375 11.7825 41.7975 12.9825 40.2375 12.9825H34.23Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1899 0.72C33.9899 0.72 30.5099 4.2075 30.5099 8.415C30.5099 12.6225 33.9899 16.11 38.1899 16.11C42.3974 16.11 45.7574 12.6225 45.7574 8.415C45.7574 4.2075 42.3974 0.72 38.1899 0.72ZM38.1899 16.83C33.5099 16.83 29.6624 13.1025 29.6624 8.415C29.6624 3.7275 33.5099 0 38.1899 0C42.7574 0 46.6049 3.7275 46.6049 8.415C46.6049 13.1025 42.7574 16.83 38.1899 16.83Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0f029519ea28d21237d9ad45f4d5057c.svg";
export { ForwardRef as ReactComponent };